import React from 'react';

import './index.scss';

export default function InitialLoader() {
  return (
    <div className='initial-loader__wrapper'>
      <div className='initial-loader'></div>
    </div>
  );
}

